import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageComponent } from './pages/page.component';
import { SignInComponent } from './pages/sign-in/sign-in.component';
import { AuthGuardService } from './services/auth-guard/auth-guard.service';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';
import { ForgetPasswordComponent } from './pages/forget-password/forget-password.component';

const routes: Routes = [
	{ path: '', redirectTo: '/sign-in', pathMatch: 'full' },
	{
		path: 'sign-in',
		component: SignInComponent,
	},
	{ path: 'forget-password', component: ForgetPasswordComponent },
	{ path: 'new-password', component: ResetPasswordComponent },
	{
		path: '',
		component: PageComponent,
		children: [
			{
				path: '',
				loadChildren: () => import('./pages/page.module').then((m) => m.PageModule),
			},
		],
		canActivate: [AuthGuardService],
	},
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule],
})
export class AppRoutingModule {}
